(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/result-boxes/assets/javascripts/views/forecastresult.js') >= 0) return;  svs.modules.push('/components/sport/result-boxes/assets/javascripts/views/forecastresult.js'); 
'use strict';

svs.sport.result_boxes.views.SwipeForecastResult = Marionette.View.extend({
  template: function(data) {
    return svs.sport.result_boxes.templates.ongoing_swipe_forecast_result(
      data
    );
  },

  ui: {
    result: '.numcorrect'
  },

  regions: {
    payout: '#payoutContainer'
  },

  modelEvents: {
    change: 'render'
  },

  onRender: function() {
    var correctAmount = $('.graph-circle-correct-amount');
    if (this.model.get('hasWon')) {
      if (correctAmount.hasClass('new-win-result-increase')) {
        correctAmount.removeClass('new-win-result-increase');
      } else if (correctAmount.hasClass('new-win-result-decrease')) {
        correctAmount.removeClass('new-win-result-decrease');
      }

      if (this.model.animateIncrease !== null) {
        if (this.model.animateIncrease) {
          correctAmount.addClass('new-win-result-increase');
        } else if (!this.model.animateIncrease) {
          correctAmount.addClass('new-win-result-decrease');
        }
      }
    }
  }
});

 })(window);